'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dList$002dTwo$002dFactor$002dAuth from "./presto.-List-Two-Factor-Auth.js";
var $p;
/** @constructor */
function $c_Lpresto_ListTwoFactorAuth$() {
}
export { $c_Lpresto_ListTwoFactorAuth$ as $c_Lpresto_ListTwoFactorAuth$ };
$p = $c_Lpresto_ListTwoFactorAuth$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_ListTwoFactorAuth$;
/** @constructor */
function $h_Lpresto_ListTwoFactorAuth$() {
}
export { $h_Lpresto_ListTwoFactorAuth$ as $h_Lpresto_ListTwoFactorAuth$ };
$h_Lpresto_ListTwoFactorAuth$.prototype = $p;
$p.l = (function() {
  return "ListTwoFactorAuth";
});
$p.cH9 = (function(x$0) {
  return new $j_presto$002e$002dList$002dTwo$002dFactor$002dAuth.$c_Lpresto_ListTwoFactorAuth(x$0.j(0), x$0.j(1));
});
var $d_Lpresto_ListTwoFactorAuth$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_ListTwoFactorAuth$, "presto.ListTwoFactorAuth$", ({
  M0: 1,
  e: 1,
  g: 1
}));
export { $d_Lpresto_ListTwoFactorAuth$ as $d_Lpresto_ListTwoFactorAuth$ };
var $n_Lpresto_ListTwoFactorAuth$;
function $m_Lpresto_ListTwoFactorAuth$() {
  if ((!$n_Lpresto_ListTwoFactorAuth$)) {
    $n_Lpresto_ListTwoFactorAuth$ = new $c_Lpresto_ListTwoFactorAuth$();
  }
  return $n_Lpresto_ListTwoFactorAuth$;
}
export { $m_Lpresto_ListTwoFactorAuth$ as $m_Lpresto_ListTwoFactorAuth$ };
//# sourceMappingURL=presto.-List-Two-Factor-Auth$.js.map
